import React, { useContext } from 'react'

import { LocaleContext } from '../locale/i18n'
import { removeWhitespace } from '../logic/contentful'
import { TeamMember } from '../logic/shared-types'

import { Avatar } from './Avatar'
import { EmailLink } from './EmailLink'
import './Expert.scss'
import './TeamMember.scss'

const Expert = ({
  member: member,
  heading,
  intro,
}: {
  member: TeamMember
  heading?: string
  intro?: string
}) => {
  const { name, customerFacingPhone, email } = member

  const { t, interpolate } = useContext(LocaleContext)

  return (
    <div className="expert">
      <div className="expert__imgWrapper">
        <Avatar variant="rounded" member={member} />
      </div>
      <h3 className="expert__heading">
        {heading || t('expert.defaultHeading')}
      </h3>
      <p className="expert__text">
        {intro ||
          interpolate('expert.defaultIntro', {
            name: name.full,
          })}
      </p>
      <div className="expert__contactDetails">
        {email && (
          <EmailLink email={email} location="solutionExpert">
            {email}
          </EmailLink>
        )}

        {customerFacingPhone && (
          <a
            href={`tel:${removeWhitespace(customerFacingPhone)}`}
            title={customerFacingPhone}
          >
            {customerFacingPhone}
          </a>
        )}
      </div>
    </div>
  )
}
export default Expert
